/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: ['contenAssetHeading', 'contentAssetContent', 'accordionItem', 'accordionButton'],
    baseStyle: {
        contentAssetBody: {
            padding: 0,
            fontSize: '12px',
            textAlign: 'left'
        },
        contentAssetHeading: {
            fontWeight: '800',
            color: 'orangeBaseColor',
            lineHeight: '16px'
        },
        contentAssetContent: {
            lineHeight: '24px',
            color: 'silver',
            fontWeight: '500'
        },
        accordionItem: {
            border: 'none',
            paddingBottom: '1rem'
        },
        accordionButton: {
            padding: '0'
        },
        footerHeading: {
            cursor: 'pointer',
            fontSize: '30px',
            fontWeight: '900',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        }
    }
}
